/*@ngInject*/
const DataSetActionsUtil = function ($rootScope, $state, $uibModal, coreMediator, configurationMediator,
                                     dataSetEditorModel, localization, loadingBarHandler,
                                     configurationActionsUtil, modalUtil, coreConstant) {

    localization.getTranslationByKey('dataSetEditorHeader').then(function (translations) {
        this.translations = translations;

        this.deleteDataSet = function (name) {
            configurationMediator.getDataSetReferences(name).then(function (result) {
                if (result.length > 0) {
                    var modalInstance = $uibModal.open({
                        templateUrl: '/configuration/dataSetReferences/dataSetReferencesModal.tpl.html',
                        controller: 'dataSetReferencesController',
                        windowClass: 'dataSetReferencesModal',
                        resolve: {
                            options: function () {
                                return {
                                    dataSetName: name,
                                    deleteDataSet: true
                                };
                            }
                        }
                    });
                    modalInstance.result.then(function (options) {
                        this.deleteDataSetContinue(options.dataSetName);
                    }.bind(this));
                } else {
                    this.deleteDataSetContinue(name);
                }
            }.bind(this));
        };

        this.viewDataSetReferences = function (name) {
            configurationMediator.getDataSetReferences(name).then(function (result) {
                var modalInstance = $uibModal.open({
                    templateUrl: '/configuration/dataSetReferences/dataSetReferencesModal.tpl.html',
                    controller: 'dataSetReferencesController',
                    windowClass: 'dataSetReferencesModal',
                    resolve: {
                        options: function () {
                            return {
                                dataSetName: name
                            };
                        }
                    }
                });
            }.bind(this));
        };

        this.deleteDataSetContinue = function (dataSetName) {
            loadingBarHandler.showNotificationLoadingBar(_.get(this.translations, 'deleteDataSetLoadingBar'));
            configurationMediator.deleteDataSetByName(dataSetName, true).then(function () {
                dataSetEditorModel.setUnsavedChanges(dataSetName, false);
                $state.go('configuration.dataSetBrowser', {});
                loadingBarHandler.concludeNotificationLoadingBar(_.get(this.translations, 'deleteDataSetSuccessLoadingBar'));
            }.bind(this));
        };

        this.saveDataSet = function (dataSet) {
            let promise;
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'savingDataSetLoadingBar'));
            promise = configurationMediator.updateDataSet(dataSet, dataSet.name).then(function (result) {
                dataSetEditorModel.updateDataSet(result);
                loadingBarHandler.concludeNotificationLoadingBar(_.get(this.translations, 'savingDataSetSuccessLoadingBar'));
            }.bind(this));
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        };

        this.exportDataSet = function (dataSetName) {
            configurationActionsUtil.exportDataSet(dataSetName);
        };

        this.discardChanges = function () {

            localization.getTranslationByKey('dataSetEditorHeader').then(function (translations) {

                var message = _.get(translations, 'discardConfirmation.summary'),
                    title = _.get(translations, 'discardConfirmation.title'),
                    cancelButtonLabel = _.get(translations, 'discardConfirmation.cancelButtonLabel'),
                    confirmButtonLabel = _.get(translations, 'discardConfirmation.confirmButtonLabel');

                function handleClose() {
                    $state.reload();
                    loadingBarHandler.showFadingNotificationLoadingBar(_.get(this.translations, 'discardConfirmation.success'));
                }

                modalUtil.showGenericConfirm({
                    cancelButtonLabel: cancelButtonLabel,
                    confirmActionButtonLabel: confirmButtonLabel,
                    summary: message,
                    title: title
                }).then(handleClose.bind(this));
            }.bind(this));
        };

    }.bind(this));
};

angular.module('ums.configuration')
    .service('dataSetActionsUtil', DataSetActionsUtil);
